import * as React from 'react';
import { Typography, GridList, GridListTile } from '@material-ui/core';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import LockIcon from '@material-ui/icons/Lock';
import AppsIcon from '@material-ui/icons/Apps';
import { NavLink } from 'react-router-dom';
import BusinessIcon from '@material-ui/icons/Business';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import BillingIcon from '@material-ui/icons/EuroSymbol';
import PeopleIcon from '@material-ui/icons/People';
import { logout, isAdmin, isBillingAdmin } from '../auth/identityAuth';

const tileStyle: React.CSSProperties = {
  background: '#fff',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  height: '100%',
  borderRadius: '5px',
  textAlign: 'center',
};

export default class Home extends React.Component<any, any> {
  public renderSubscriptions() {
    if (isAdmin) {
      return (
        <NavLink to="/subscriptions/">
          <div style={tileStyle}>
            <div className="padding-bottom-24" />
            <CreditCardIcon color="secondary" style={{ fontSize: 70 }} />
            <Typography color="primary">Data user</Typography>
          </div>
        </NavLink>
      );
    }
    return (
      <div style={tileStyle}>
        <div className="padding-bottom-15" />
        <CreditCardIcon color="disabled" style={{ fontSize: 70 }} />
        <Typography color="textSecondary">Subscriptions</Typography>
        <Typography color="textSecondary">(Log in as admin to access this feature)</Typography>
      </div>
    );
  }

  public renderDataProvider() {
    if (isAdmin) {
      return (
        <NavLink to="/providerassets/">
          <div style={tileStyle}>
            <div className="padding-bottom-24" />
            <LockIcon color="secondary" style={{ fontSize: 70 }} />
            <Typography color="primary">Data provider</Typography>
          </div>
        </NavLink>
      );
    }
    return (
      <div style={tileStyle}>
        <div className="padding-bottom-15" />
        <LockIcon color="disabled" style={{ fontSize: 70 }} />
        <Typography color="textSecondary">Provider</Typography>
        <Typography color="textSecondary">(Log in as admin to access this feature)</Typography>
      </div>
    );
  }

  public renderAssetOwner() {
    if (isAdmin) {
      return (
        <NavLink to="/verifications/">
          <div style={tileStyle}>
            <div className="padding-bottom-24" />
            <AppsIcon color="secondary" style={{ fontSize: 70 }} />
            <Typography color="primary">Asset owner</Typography>
          </div>
        </NavLink>
      );
    }
    return (
      <div style={tileStyle}>
        <div className="padding-bottom-15" />
        <AppsIcon color="disabled" style={{ fontSize: 70 }} />
        <Typography color="textSecondary">Asset owner</Typography>
        <Typography color="textSecondary">(Log in as admin to access this feature)</Typography>
      </div>
    );
  }

  public renderCommunities() {
    return (
      <NavLink to="/community-management">
        <div style={tileStyle}>
          <div className="padding-bottom-24" />
          <PeopleIcon color="secondary" style={{ fontSize: 70 }} />
          <Typography color="primary">Commmunity Management</Typography>
        </div>
      </NavLink>
    );
  }

  public renderOrganization() {
    if (isAdmin) {
      return (
        <NavLink to="/organization/settings/">
          <div style={tileStyle}>
            <div className="padding-bottom-24" />
            <BusinessIcon color="secondary" style={{ fontSize: 70 }} />
            <Typography color="primary">My Organization</Typography>
          </div>
        </NavLink>
      );
    }
    return (
      <div style={tileStyle}>
        <div className="padding-bottom-15" />
        <BusinessIcon color="disabled" style={{ fontSize: 70 }} />
        <Typography color="textSecondary">Organization</Typography>
        <Typography color="textSecondary">(Log in as admin to access this feature)</Typography>
      </div>
    );
  }

  public renderBilling() {
    if (isBillingAdmin) {
      return (
        <NavLink to="/billing/">
          <div style={tileStyle}>
            <div className="padding-bottom-24" />
            <BillingIcon color="secondary" style={{ fontSize: 70 }} />
            <Typography color="primary">Billing</Typography>
          </div>
        </NavLink>
      );
    }
    return (
      <div style={tileStyle}>
        <div className="padding-bottom-15" />
        <BillingIcon color="disabled" style={{ fontSize: 70 }} />
        <Typography color="textSecondary">Billing</Typography>
        <Typography color="textSecondary">
          (Log in as Billing Admin)
        </Typography>
      </div>
    );
  }

  public renderLogout() {
    return (
      <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={logout}>
        <div style={tileStyle}>
          <div className="padding-bottom-24" />
          <LogoutIcon color="secondary" style={{ fontSize: 70 }} />
          <Typography color="primary">Log out</Typography>
        </div>
      </a>
    );
  }

  public render() {
    return (
      <div className="padding-24">
        <Typography variant="display1" color="secondary" gutterBottom={true}>
          Welcome to the NxtPort Console
        </Typography>
        <Typography>
          This is the central hub for managing your NxtPort account, subscriptions, who can access
          your data, ... .
        </Typography>
        <div className="padding-bottom-24" />
        <Typography variant="title" className="padding-bottom-24">
          Choose your role
        </Typography>
        <GridList cellHeight={160} cols={4} spacing={24}>
          <GridListTile cols={1}>{this.renderSubscriptions()}</GridListTile>
          <GridListTile cols={1}>{this.renderDataProvider()}</GridListTile>
          <GridListTile cols={1}>{this.renderAssetOwner()}</GridListTile>
          <GridListTile cols={1}>{this.renderOrganization()}</GridListTile>
          <GridListTile cols={1}>{this.renderBilling()}</GridListTile>
          {this.props.showCommunitiesLink &&
            <GridListTile cols={1}>{this.renderCommunities()}</GridListTile>
          }
          <GridListTile cols={1}>{this.renderLogout()}</GridListTile>
        </GridList>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/pages/Dashboard.tsx